var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.disabled_pass && !_vm.disabled ? _c('div', {
    staticClass: "cursor-pointer flex hover:font-medium items-center w-max",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.add();
      }
    }
  }, [_c('span', {
    staticClass: "plus-button 2xl:h-10 2xl:w-10 2xl:mt-2"
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1), _vm._v(" "), _vm.responsive ? _c('span', {
    staticClass: "text-base text-gray-600 ml-3 hidden md:inline flex-initial"
  }, [_vm._v("\n    " + _vm._s(_vm.libelle) + "\n  ")]) : _c('span', {
    staticClass: "text-base text-gray-600 ml-3 flex-initial"
  }, [_vm._v("\n    " + _vm._s(_vm.libelle) + "\n  ")]), _vm._v(" "), _vm.withDropdown ? _c('icon', {
    staticClass: "ml-2.5 text-teal-600",
    attrs: {
      "name": "chevron-down"
    }
  }) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }